import React, { useState, useMemo, useCallback, useEffect } from "react";
import Select from "../Select";
import { SelectProps } from "antd/lib/select";
import { debounce } from "lodash";
import compact from "lodash/compact";
import metricServices from "./services/metricServices";
import useSWR from "swr";
import { useGetLocalizedText } from "locales/hooks";
import { IStatisticConfig } from "../Statistic/services/typings";
import { useTranslation } from "react-i18next";

interface IProps extends SelectProps<any> {
  kind: "campaign" | "campaign-onsite";
}

const MetricsSelect = (props: IProps) => {
  const { value, onChange, kind, ...rest } = props;
  const [searchText, setSearchText] = useState("");

  const getLocalizedText = useGetLocalizedText();

  const { data: metrics, error } = useSWR(
    [kind],
    () => metricServices.getMetrics(kind),
    {
      refreshWhenHidden: false,
      revalidateOnFocus: false,
      refreshWhenOffline: false,
      revalidateOnReconnect: false,
    }
  );

  const filteredMetrics = useMemo(
    () =>
      compact([
        ...(metrics || []),
        metrics?.length === 0 ? value : undefined,
      ]).filter(
        (s: IStatisticConfig) =>
          !searchText ||
          getLocalizedText(s.display_name)
            ?.toLowerCase()
            .includes(searchText.toLowerCase())
      ),
    [metrics, searchText, value, getLocalizedText]
  );

  const debouncedSetSearchText = useMemo(
    () => debounce(setSearchText, 500),
    [setSearchText]
  );

  const { t } = useTranslation();

  return (
    <Select
      placeholder={t("common.metrics")}
      // loading={loading}
      data={filteredMetrics}
      onSearch={debouncedSetSearchText}
      // notFoundContent={loading ? null : <Empty />}
      getDisplayText={(val) => getLocalizedText(val.display_name)}
      getValue={(val) => val.field}
      showSearch
      filterOption={false}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
};

export default MetricsSelect;
